<template>
    <div id="container" type="vdpp">
        <div class="page page-dpp" v-ga:page="{pageType:'vdpp', glb: glb, state: dpp}" v-ga:request="{pageType:'vdpp', state: dpp}">
            <mvtHeader :searchInput="searchInput" :geoInfo="dpp.geo"></mvtHeader>
            <div class="dpp-nav">
                <dppNav />
                <dppButton />
            </div>
            <dppBar/>
            <div class="dpp-layout" :class="!dpp.isActive ? 'dpp-layout-inactive' : 'dpp-layout-active'" >
                <PropertySchema :data="dpp" :enableRealEstateSchema="isForSaleActive" :enableSingleFamilySchema="isForSaleActive" />
                <dppPhoto>
                    <template #tag>
                        <propertyTags class="dpp-photo-label dpp-photo-tags-container"/>
                    </template>
                </dppPhoto>
                <div class="dpp-info">
                    <propertySummaryTitle />
                </div>
                <mvtReorder
                    class="dpp-detail dpp-detail-reorder"
                    :order="detailOrder"
                >
                    <propertyOpendoorPanel
                        orderKey="propertyOpendoorPanel"
                        id="propertyOpendoorPanel"
                        v-if="opendoorPanelVisible"
                        :opendoor-address-details="opendoorAddressDetails"
                    />
                    <section id="propertyDetailPanel" class="section-outline" orderKey="propertyDetailPanel">
                        <div class="dpp-info-panel grid gap-3 xs-grid-cols-1">
                            <div class="flex horizontal middle">
                                <h2 class="f2 text-bold">About {{ dpp.geo.address }}</h2>
                                <button class="text-brand" v-if="!dpp.isActive" type="button" aria-label="Edit property data" @click="popContactUs">
                                    <i class="f2 icon-pencil"></i>
                                </button>
                            </div>
                            <propertySummaryDetails/>
                            <propertyDesc :buyingOffice="buyingOffice"/>
                            <propertyTourCta v-if="dpp.isActive && !dpp.isRentals" />
                            <div v-if="dpp && dpp.features && dpp.features.length">
                                <propertyFeature />
                            </div>
                        </div>
                    </section>
                    <section v-if="showDppAds" class="dpp-ad-below-details" orderKey="dppAdBelowDetails">
                        <mvtAds :options="{ type: 'dpp', index: 0, isActive: dpp.isActive }" :key="'dpp_0_' + dpp.isActive" />
                    </section>
                    <propertyEstimate
                        orderKey="propertyEstimatePanel"
                        id="propertyEstimatePanel"
                        v-if="!dpp.isRentals"
                        :isMarket5YLoaded="isMarket5YLoaded"
                        :isActive="!dpp.isActive"
                    />

                    <section
                        orderKey="propertyBreadcrumbPanel"
                        id="propertyBreadcrumbPanel"
                    >
                        <mvtBreadcrumb :geo="dpp.geo" :isActive="dpp.isActive"></mvtBreadcrumb>
                    </section>

                    <propertySaleProceeds
                        orderKey="propertySaleProceedsPanel"
                        id="propertySaleProceedsPanel"
                        v-if="!dpp.isActive && !dpp.isRentals"
                        :isActive="true"
                    />

                    <section orderKey="propertyCashOfferPanel" v-if="!dpp.isActive && !dpp.isRentals && !getSplit('movoto-opendoor-panel-CW-4375')"  comp="mvtSellPanel">
                        <div class="panel-cashoffer">
                            <i class="icon-cash"></i>
                            <div>
                                <h2 class="panel-cashoffer-title"> <span>Thinking of selling?</span>  <span>Get a Cash Offer.</span></h2>
                                <ul>
                                    <li><i class="icon-check f3"></i> A smooth, fast sale</li>
                                    <li><i class="icon-check f3"></i> Skip staging and repairs</li>
                                    <li><i class="icon-check f3"></i> No strings attached</li>
                                </ul>
                                <button id="sellPanelCta" type="button" class="btn secondary medium no-stroke"  @click="sendCashOffer">Get a cash offer</button>
                            </div>
                        </div>
                    </section>

                    <propertyHistory
                        orderKey="propertyHistoryPanel"
                        id="propertyHistoryPanel"
                        :isActive="!dpp.isActive"
                    />

                    <propertyNeighborhood
                        orderKey="propertyMapPanel"
                        id="propertyMapPanel"
                    />

                    <propertyMarket
                        orderKey="propertyMarketPanel"
                        id="propertyMarketPanel"
                        v-if="!dpp.hideMarketStatistics && !dpp.isRentals"
                        :fields="fields"
                        :isMarket5YLoaded="isMarket5YLoaded"
                        :isActive="!dpp.isActive"
                    />

                    <propertyNearbyHomeValues
                        orderKey="propertyNearbyHomeValuesPanel"
                        id="propertyNearbyHomeValuesPanel"
                        v-if="getSplit('movoto-nearby-home-values-CW-4390') && (dpp.showAsPR || dpp.isSold) && !dpp.isRentals"
                    />

                    <section class="section-outline" orderKey="propertyInlineHotlead" id="propertyInlineHotlead">
                        <div class="inline bg-default corner outline large">
                            <dppSuggestion v-if="showDppInlineCommentSuggestTreatment" />
                            <mvtHotleadForm v-else :options="inlineHotleadOpt"
                        />
                        </div>
                    </section>

                    <propertyMortgage
                        orderKey="propertyMortgagePanel"
                        id="propertyMortgagePanel"
                        v-if="!dpp.isRentals"
                        :isActive="true"
                    />

                    <propertyCommute
                        orderKey="propertyCommutePanel"
                        id="propertyCommutePanel"
                        v-if="dpp.isActive"
                    />

                    <propertySchedule orderKey="propertySchedulePanel" id="propertySchedulePanel" v-if="dpp.isActive" />

                    <propertySchool
                        orderKey="propertySchoolPanel"
                        id="propertySchoolPanel"
                        :isActive="true"
                    />

                    <propertyPoi
                        orderKey="propertyPoiPanel"
                        id="propertyPoiPanel"
                        :isActive="true"
                        :disableCollapse="true"
                    />

                    <section
                        class="section-outline"
                        orderKey="propertyVeteranPanel"
                        id="propertyVeteranPanel"
                        comp="propertyVeteran"
                         v-if="showVeteran"
                    >
                    <div class="property-veteran"
                    :class="{'active': collpaseVeteran}">
                        <button type="button" @click="toggleVeteran"><i :class="collpaseVeteran ? 'icon-angle-down' : 'icon-angle-up'"></i></button>
                        <img :src="glb.cdnUrl + 'vimages/lower-welcome-bg-va.webp'"
                            loading="lazy"
                            alt="Lower Mortgage offers Veterans"
                        />
                        <h3 type="button" @click="toggleVeteran"><div class="text-bold f2">Veterans</div> <div class="f5 text-gray" v-show="showVeteran">Veterans take advantage of your unique benefits.</div></h3>

                        <div>
                            <div>Take advantage of unique benefits that make homeownership easier and more affordable.</div>
                            <button class="btn secondary medium" @click="show3rdPartyForm({ id: 'veteransdrawer', url: 'veteransdrawer', cta: 'Prequalify for a 0% down VA loan', clickEvent: $event })" type="button">Prequalify for a 0% down VA loan</button>
                        </div>
                    </div>
                    </section>

                    <dppSchedule
                        orderKey="dppSchedule"
                        id="dppSchedulePanel"
                        v-if="componentMounted"
                        v-show="false"
                        ref="viewSchedule"
                        :assignedAgent="glb.agent"
                    />

                    <section
                        v-if="showDppAds && dpp.nearbyHomes && dpp.nearbyHomes.length"
                        class="dpp-ad-above-nearby"
                        orderKey="dppAdAboveNearby"
                    >
                        <mvtAds :options="{ type: 'dpp', index: 2, isActive: dpp.isActive }" :key="'dpp_2_' + dpp.isActive" />
                    </section>
                    <section
                        orderKey="nearbyHomes"
                        id="nearbyHomes"
                        class="property-nearby new"
                        v-if="dpp.nearbyHomes && dpp.nearbyHomes.length"
                    >
                        <div class="grid xs-grid-cols-1">
                            <h2 class="f2 text-bold">
                                Nearby
                                <a
                                    class="link"
                                    :href="`${glb.appUrl}${dpp.geo.cityCode}-${dpp.geo.stateCode}/`"
                                >homes for sale in {{ dpp.geo.city }}, {{ dpp.geo.state }}</a>
                            </h2>
                            <mvtListingCarousel :listings="dpp.nearbyHomes" />
                        </div>
                    </section>

                    <section
                        orderKey="nearbySoldHomes"
                        id="nearbySoldHomes"
                        class="property-nearby new"
                        v-if="dpp.nearbySoldHomes && dpp.nearbySoldHomes.length"
                    >
                        <div class="grid xs-grid-cols-1">
                            <h2 class="f2 text-bold">
                                Nearby
                                <a
                                    class="link"
                                    :href="`${glb.appUrl}${dpp.geo.cityCode}-${dpp.geo.stateCode}/sold/`"
                                >recently sold homes in {{ dpp.geo.city }}, {{ dpp.geo.state }}</a>
                            </h2>
                            <mvtListingCarousel :listings="dpp.nearbySoldHomes" />
                        </div>
                    </section>

                    <section
                        orderKey="nearbyRentHomes"
                        id="nearbyRentHomes"
                        class="property-nearby new"
                        v-if="dpp.isRentals && dpp.nearbyRentHomes && dpp.nearbyRentHomes.length"
                    >
                        <div class="grid xs-grid-cols-1">
                            <h2 class="f2 text-bold">
                                Nearby <a class="link" v-if="rentalCaouselLink" :href="rentalCaouselLink">{{ rentalCaouselText }}</a>
                            </h2>
                            <mvtListingCarousel :listings="dpp.nearbyRentHomes" />
                        </div>
                    </section>

                    <section
                        orderKey="nearbyNewHomes"
                        id="nearbyNewHomes"
                        class="property-nearby new"
                        v-if="dpp.nearbyNewHomes && dpp.nearbyNewHomes.length"
                    >
                        <div class="grid xs-grid-cols-1">
                            <h2 class="f2 text-bold">
                                <a
                                    class="link"
                                    :href="`${glb.appUrl}${dpp.geo.stateCode}/${dpp.geo.zipcode}/new-7/`"
                                >
                                    Newest listings in {{ dpp.geo.zipcode }}
                                </a>
                            </h2>
                            <mvtListingCarousel :listings="dpp.nearbyNewHomes" />
                        </div>
                    </section>

                    <propertyGeoLink
                        id="propertyGeoLinkPanel"
                        orderKey="propertyGeoLink"
                    />

                    <propertyGeoFilterLink
                        id="propertyGeoFilterLinkPanel"
                        orderKey="propertyGeoFilterLink"
                        :inventoryInfo="glb?.listingCountObj?.city"
                    />

                    <section orderKey="dppAsidePanel" class="hidden-md hidden-lg section-outline">
                        <div class="dpp-aside-panel"  v-if="!dpp.isRentals && ((hasOJOAgent && getSplit('movoto-cta-move-CW-3672')) || preApprovalButtonObj || showHelocAsidePanel)">
                            <img v-if="!showHelocAsidePanel" :src="glb.cdnUrl + 'vimages/dpp-lower-payment.webp'" alt="Welcome Home Movoto" loading="lazy"/>
                            <div v-if="!hasOJOAgent && getSplit('movoto-cta-move-CW-3672')">
                                <div class="text-bold">
                                    Get matched with a skilled local agent who will guide you through your real estate journey.
                                </div>
                                <button type="button"  class="btn medium"  @click="openHotlead(secondaryCtaTxt)">{{secondaryCtaTxt}} </button>
                            </div>
                            <div v-else-if="showHelocAsidePanel && preApprovalButtonObj">
                                <div class="text-bold f2 lh-normal">
                                    Get cash for up to 95% of your home's value in as little as five days
                                </div>
                                <div class="lh-normal">
                                    Keep your mortgage, and use the cash for anything you want - no restrictions.
                                </div>
                                <button type="button" class="btn medium secondary" @click="showForm(preApprovalButtonObj, $event)">{{preApprovalButtonObj.cta}}</button>
                            </div>
                            <div v-else-if="preApprovalButtonObj">
                                <div class="text-bold f2 lh-normal">
                                    <span v-if="dpp.isActive">
                                        When you find that perfect home, be ready to make an offer.
                                    </span>
                                    <span v-else>
                                        Lower your payment with the loan terms that fit you.
                                    </span>
                                </div>
                                <button type="button" class="btn medium" @click="showForm(preApprovalButtonObj, $event)">{{preApprovalButtonObj.cta}}</button>
                            </div>
                        </div>
                    </section>

                </mvtReorder>
                <aside class="dpp-aside" comp="dppAside">
                    <div>
                        <div class="dpp-panel-hotleadbutton">
                            <dppHotleadButton :assignedAgent="glb.agent" :requestTourSubtext="ctaRequestTourSubtext"></dppHotleadButton>
                        </div>

                        <div class="dpp-aside-panel hidden-xs hidden-sm" v-if="!dpp.isRentals && ((hasOJOAgent && getSplit('movoto-cta-move-CW-3672')) || preApprovalButtonObj || showHelocAsidePanel)">
                            <img v-if="!showHelocAsidePanel" :src="glb.cdnUrl + 'vimages/dpp-lower-payment.webp'" alt="Welcome Home Movoto" loading="lazy"/>
                            <div v-if="!hasOJOAgent && getSplit('movoto-cta-move-CW-3672')">
                                <div class="text-bold">
                                    Get matched with a skilled local agent who will guide you through your real estate journey.
                                </div>
                                <button type="button"  class="btn medium"  @click="openHotlead(secondaryCtaTxt)">{{secondaryCtaTxt}} </button>
                            </div>
                            <div v-else-if="showHelocAsidePanel && preApprovalButtonObj">
                                <div class="text-bold f2 lh-normal">
                                    Get cash for up to 95% of your home's value in as little as five days
                                </div>
                                <div class="lh-normal">
                                    Keep your mortgage, and use the cash for anything you want - no restrictions.
                                </div>
                                <button type="button" class="btn medium" @click="showForm(preApprovalButtonObj, $event)">{{preApprovalButtonObj.cta}}</button>
                            </div>
                            <div v-else-if="preApprovalButtonObj">
                                <div class="text-bold f2 lh-normal">
                                    <span v-if="dpp.isActive">
                                        When you find that perfect home, be ready to make an offer.
                                    </span>
                                    <span v-else>
                                        Lower your payment with the loan terms that fit you.
                                    </span>
                                </div>
                                <button type="button" class="btn medium" @click="showForm(preApprovalButtonObj, $event)">{{preApprovalButtonObj.cta}}</button>
                            </div>
                        </div>
                        <div v-if="showDppAds" class="dpp-ad-side-rail hidden-xs hidden-sm">
                            <mvtAds :options="{ type: 'dpp', index: 1, isActive: dpp.isActive }" :key="'dpp_1_' + dpp.isActive" />
                        </div>
                    </div>
                </aside>
            </div>
            <mvtFooter id="footer" :geoInfo="dpp.geo" />
            <template v-if="popPhotoLoaded">
                <propertyPopPhotoSingle ref="popPhotoSingle" :popPhotoIndex="popPhotoIndex" :popPhotoCateIndex="popPhotoCateIndex"></propertyPopPhotoSingle>
            </template>
            <template v-if="pop3dLoaded">
                <propertyPop3d ref="pop3d" :pop3dUrl="pop3dUrl"></propertyPop3d>
            </template>
            <template v-if="popOpendoorLoaded">
                <propertyPopOpendoor ref="popOpendoor"></propertyPopOpendoor>
            </template>
            <template v-if="popMapLoaded">
                <propertyPopMap ref="popMap" :popMapTypeId="popMapTypeId" :popStreetView="popStreetView" :popFilter="popFilter" :popActiveMarker="popActiveMarker"></propertyPopMap>
            </template>
        </div>
        <template v-if="componentMounted">
            <div class="dpp-pop-chat" :class="{'show': activeChat}">
                <div class="dpp-pop-chat-msg p-x-0 p-y-0 corner">
                    <div class="p-x-3 p-y-3 text-bold">
                        <div @click="openChatPop">
                            <div v-if="assignedAgent && assignedAgent.firstName">
                                <div class="f7 m-b-1">Your agent, {{ assignedAgent.firstName }} says</div>
                                <div>Hey there! Let me know if you have any questions about this property.</div>
                            </div>
                            <div v-else>An experienced real estate agent wants to speak to you about {{ !dpp.isActive ? 'selling' :'' }} this property right now!</div>
                        </div>
                    </div>
                    <button type="button" aria-label="Dismiss message" @click="closeChat"><i class="icon-times"></i></button>
                </div>
                <img v-if="assignedAgent && assignedAgent.photoUrl" :title="assignedAgent.fullName" @click="openChatPop" class="circle default" alt="Agent Avatar" :src="assignedAgent.photoUrl" />
                <button v-else type="button" aria-label="Connect with a local real estate agent" @click="openChatPop" class="circle default"><i class="icon-user-home f3"></i></button>
            </div>
            <mvtFeed :property="dpp"></mvtFeed>
            <mvtPopSignin />
            <mvtDialog ref="dppTransPop" v-ga:dialog>
                <div class="grid xs-grid-cols-1">
                    <div class="f4 text-center text-bold">Top local Real Estate agents</div>
                    <div>Match with experienced, local real estate agents from the most trusted brokerages near you, including Coldwell Banker, Keller Williams, Compass, Better Homes and Gardens, EXP, Century 21, RE/MAX, and more</div>
                    <ul class="grid xs-grid-cols-2 text-center"><li><i class="icon-hand-care f3"></i> <p>Carefully Vetted </p> <p>Professionals</p></li> <li><i class="icon-statistics-report f3"></i> <p class="f7">Experienced</p> <p class="f7">Negotiators</p></li> <li><i class="icon-user-check f3"></i> <p class="f7">Local Market</p> <p class="f7">Real Estate Experts</p></li> <li><i class="icon-shield-star f3"></i> <p class="f7">25,000+</p> <p class="f7">Top-Rated Agents</p></li> <li><i class="icon-doc f3"></i> <p class="f7">3+ Years in</p> <p class="f7">the Industry</p></li> <li><i class="icon-map-pin-home f3"></i> <p class="f7">Nationwide</p> <p class="f7">Representation</p></li></ul>
                </div>
            </mvtDialog>
            <mvtDialog ref="dppAvmDisclaimer3" v-ga:dialog class="home-value-test">
                <div class="grid xs-grid-cols-1">
                     <div class="dialog-profile">
                        <div class="circle huge default"><img loading="lazy" :src=" glb.cdnUrl + 'vimages/avm-img.svg'"/></div>
                    </div>
                    <div class="f4 text-bold text-center">Rental Estimate</div>
                    <div>We determine the rental value of this property by conducting a comparative analysis with similar homes for rent in the nearby area. Our assessment considers essential data points, such as location, square footage, number of bedrooms and bathrooms, and other relevant property characteristics.</div>
                </div>
            </mvtDialog>

            <mvtDialog ref="dppAvmDisclaimer4" v-ga:dialog>
                <div class="grid xs-grid-cols-1">
                     <div class="dialog-profile">
                        <div class="circle huge default"><img loading="lazy" :src=" glb.cdnUrl + 'vimages/avm-img.svg'"/></div>
                    </div>
                    <div class="f4 text-bold text-center">Gross Rent Multiplier</div>
                    <div>Gross rent multiplier is the ratio of the price of a real estate investment to its annual rental income before accounting for expenses such as property taxes, insurance, and utilities; GRM is the number of years the property would take to pay for itself in gross received rent.</div>
                </div>
            </mvtDialog>

            <mvtDialog ref="dppHotPop" v-ga:dialog>
                <div class="grid xs-grid-cols-1">
                    <div class="f4 text-bold lh-small" v-html="popHotPanelTitle"></div>
                    <div v-html="popHotPanelContent"></div>
                </div>
            </mvtDialog>
            <mvtPopOwnup ref="popOwnup"
                :address="dpp.geo.address"
                :city="dpp.geo.city"
                :zipcode="dpp.geo.zipcode"
                :state="dpp.geo.state"
                :county="dpp.geo.county"
                :propertyType="ownUpPropertyType"
                :purchasePrice="dpp.price"
            ></mvtPopOwnup>
        </template>

        <PrimaryImageSchema/>
        <ApplicationSchema />
        <VirtualTourSchema />
        <DataFeedItemSchema />
        <mvtDialogCenter></mvtDialogCenter>
        <mvtToastCenter />
    </div>
</template>

<script src="./page-dpp.js"></script>

<style lang="scss">
@use "./page-dpp.scss" as *;
</style>
